import { colors } from '../../shared/styles/baseStyle';

const boxStyle = {
  width: 40,
  height: 48,
  margin: '0 4px',
  textAlign: 'center',
  fontSize: 18,
  fontWeight: 600,
  color: colors.anytimeBlue,
  borderRadius: 10,
  background: '#fafafa',
  outline: 'none',
  transition: 'border-color 0.2s'
};
export default boxStyle;
